export enum ResourceTypeEnum{
  Image = "image",
  Video = "video",
}

export type ResourceType = 'image' | 'video';

export interface ResourceListItem {
  type: ResourceType;
  url: string;
  coverImageUrl?: string;
}

export interface ExtraParams {
  'exptag': string;
  'data-exptag-json-param': string;
  'data-exptag-config': string;
}

export type ImageOperateType = 'tryAgain';
export type VideoOperateType = 'play' | 'pause' | 'mute' | 'voiced' | 'tryAgain';
export type ResourceOperateType = ImageOperateType | VideoOperateType;

interface ImageTrackExtraParams {
  previewImage?: ExtraParams;
  tryAgainBtn?: ExtraParams;
}

interface VideoTrackExtraParams {
  previewVideo?: ExtraParams;
  tryAgainBtn?: ExtraParams;
  volumeBtn?: ExtraParams;
}

interface TrackExtraParams {
  image?: ImageTrackExtraParams;
  video?: VideoTrackExtraParams;
}

interface CurrentResourceInfo {
  index: number;
  type: ResourceType;
  url: string;
}

interface CurrentImageBaseInfo { }
type CurrentImageInfo = CurrentResourceInfo & CurrentImageBaseInfo;

interface CurrentVideoBaseInfo {
  volume: number;
}
type CurrentVideoInfo = CurrentResourceInfo & CurrentVideoBaseInfo;

type clickHandler = (
  operateType: ImageOperateType | VideoOperateType,
  currentResourceInfo: CurrentImageInfo | CurrentVideoInfo
) => void;

type ImageOperateHandler = (operateType: ImageOperateType) => void;
type VideoOperateHandler = (operateType: VideoOperateType, videoBaseInfo: CurrentVideoBaseInfo) => void;

export interface PreviewResourcePropsType {
  open: boolean;
  resourceList: ResourceListItem[];
  defaultUrl: string;
  trackExtraParams?: TrackExtraParams;
  bottomSlot?: (currentIndex: number) => React.ReactNode;
  previewIndexChangeHandler?: (currentIndex: number) => void;
  clickHandler?: clickHandler;
  errorHandler?: (currentResourceInfo: CurrentResourceInfo) => void;
  closeHandler: () => void;
  // 传送门 Portal TODO
}

export interface PreviewImagePropsType {
  src: string;
  alt?: string;
  trackExtraParams: ImageTrackExtraParams;
  resourceOperateHandler: ImageOperateHandler;
  errorHandler: () => void;
}

export interface PreviewVideoPropsType {
  src: string;
  trackExtraParams: VideoTrackExtraParams;
  resourceOperateHandler: VideoOperateHandler;
  errorHandler: () => void;
}